import { render, staticRenderFns } from "./ZyToolsDetail.vue?vue&type=template&id=34d01494&scoped=true"
import script from "./ZyToolsDetail.vue?vue&type=script&lang=js"
export * from "./ZyToolsDetail.vue?vue&type=script&lang=js"
import style0 from "./ZyToolsDetail.vue?vue&type=style&index=0&id=34d01494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d01494",
  null
  
)

export default component.exports